var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import { Popper as ReactPopper } from 'react-popper';
import { getTarget, isInDOMSubtrees, keyCodes } from '../Utils';
var DEFAULT_DELAYS = {
    show: 0,
    hide: 50,
};
var PopoverWrapper = /** @class */ (function (_super) {
    __extends(PopoverWrapper, _super);
    function PopoverWrapper(props) {
        var _this = _super.call(this, props) || this;
        _this._isMounted = false;
        _this.getRef = function (ref) {
            var popover = ref;
            _this.setState({ popover: popover });
        };
        _this.updateTarget = function () {
            var target = _this.props.target;
            var _a = _this.state, targets = _a.targets, currentTargetElement = _a.currentTargetElement;
            var newTarget = getTarget(target, true);
            if (newTarget !== targets) {
                _this.removeTargetEvents();
                targets = newTarget ? Array.from(newTarget) : [];
                currentTargetElement = currentTargetElement || targets[0];
                _this.setState({
                    targets: targets,
                    currentTargetElement: currentTargetElement,
                }, function () {
                    _this.addTargetEvents();
                });
            }
        };
        _this.addTargetEvents = function () {
            var trigger = _this.props.trigger;
            var targets = _this.state.targets;
            if (trigger) {
                var triggers = trigger.split(' ');
                if (triggers.indexOf('manual') === -1) {
                    if (triggers.indexOf('click') > -1 || triggers.indexOf('legacy') > -1) {
                        document.addEventListener('click', _this.handleDocumentClick, true);
                    }
                    if (targets && targets.length) {
                        if (triggers.indexOf('hover') > -1) {
                            _this.addEventOnTargets('mouseover', _this.showWithDelay, true);
                            _this.addEventOnTargets('mouseout', _this.hideWithDelay, true);
                        }
                        if (triggers.indexOf('focus') > -1) {
                            _this.addEventOnTargets('focusin', _this.show, true);
                            _this.addEventOnTargets('focusout', _this.hide, true);
                        }
                        _this.addEventOnTargets('keydown', _this.onKeyDown, true);
                    }
                }
            }
        };
        _this.onKeyDown = function (e) {
            if (e.key === 'Escape') {
                _this.hide(e);
            }
            var isOpen = _this.props.isOpen;
            if (isOpen) {
                if ([keyCodes.down, keyCodes.up].indexOf(e.which) > -1 ||
                    ([keyCodes.n, keyCodes.p].indexOf(e.which) > -1 && e.ctrlKey)) {
                    var $menuitems = _this.getMenuItems();
                    var index = $menuitems.indexOf(e.target);
                    if (keyCodes.up === e.which || (keyCodes.p === e.which && e.ctrlKey)) {
                        index = index !== 0 ? index - 1 : $menuitems.length - 1;
                    }
                    else if (keyCodes.down === e.which || (keyCodes.n === e.which && e.ctrlKey)) {
                        index = index === $menuitems.length - 1 ? 0 : index + 1;
                    }
                    $menuitems[index].focus();
                }
            }
        };
        _this.addEventOnTargets = function (type, handler, isBubble) {
            var targets = _this.state.targets;
            targets.forEach(function (target) {
                target.addEventListener(type, handler, isBubble);
            });
        };
        _this.removeEventOnTargets = function (type, handler, isBubble) {
            var targets = _this.state.targets;
            targets.forEach(function (target) {
                target.removeEventListener(type, handler, isBubble);
            });
        };
        _this.handleDocumentClick = function (e) {
            var _a = _this.props, trigger = _a.trigger, isOpen = _a.isOpen;
            var _b = _this.state, targets = _b.targets, hideTimeout = _b.hideTimeout, popover = _b.popover;
            var triggers = trigger.split(' ');
            var popoverArea = popover && popover.querySelector('[role="menu"]');
            if (triggers.indexOf('legacy') > -1 && (isOpen || isInDOMSubtrees(e.target, targets))) {
                if (hideTimeout) {
                    _this.clearHideTimeout();
                }
                if (isOpen) {
                    _this.hideWithDelay(e);
                }
                else if (!isOpen) {
                    _this.showWithDelay(e);
                }
            }
            else if (triggers.indexOf('click') > -1 && isInDOMSubtrees(e.target, popoverArea)) {
                if (hideTimeout) {
                    _this.clearHideTimeout();
                }
                if (!isOpen) {
                    _this.showWithDelay(e);
                }
                else {
                    _this.hideWithDelay(e);
                }
            }
        };
        _this.hideWithDelay = function (e) {
            var showTimeout = _this.state.showTimeout;
            if (showTimeout) {
                _this.clearShowTimeout();
            }
            var hideTimeout = setTimeout(function () {
                _this.hide(e);
                _this.getDelay('hide');
            });
            _this.setState({ hideTimeout: hideTimeout });
        };
        _this.showWithDelay = function (e) {
            var hideTimeout = _this.state.hideTimeout;
            if (hideTimeout) {
                _this.clearHideTimeout();
            }
            var showTimeout = setTimeout(function () {
                _this.show(e);
                _this.getDelay('show');
            });
            _this.setState({ showTimeout: showTimeout });
        };
        _this.hide = function (e) {
            var isOpen = _this.props.isOpen;
            if (isOpen) {
                _this.clearHideTimeout();
                var currentTargetElement = null;
                _this.toggle(e);
                _this.setState({ currentTargetElement: currentTargetElement });
            }
        };
        _this.getDelay = function (key) {
            return DEFAULT_DELAYS[key];
        };
        _this.show = function (e) {
            var _a = _this.props, isOpen = _a.isOpen, target = _a.target;
            if (!isOpen) {
                _this.clearShowTimeout();
                var currentTargetElement = document.getElementById(target);
                _this.setState({ currentTargetElement: currentTargetElement });
                _this.toggle(e);
            }
        };
        _this.toggle = function (e) {
            var _a = _this.props, disabled = _a.disabled, toggle = _a.toggle;
            if (disabled || !_this._isMounted) {
                return e && e.preventDefault();
            }
            toggle(e);
        };
        _this.clearHideTimeout = function () {
            var hideTimeout = _this.state.hideTimeout;
            clearTimeout(hideTimeout);
            _this.setState({ hideTimeout: undefined });
        };
        _this.clearShowTimeout = function () {
            var showTimeout = _this.state.showTimeout;
            clearTimeout(showTimeout);
            _this.setState({ showTimeout: undefined });
        };
        _this.removeTargetEvents = function () {
            var targets = _this.state.targets;
            if (targets) {
                _this.removeEventOnTargets('mouseover', _this.showWithDelay, true);
                _this.removeEventOnTargets('mouseout', _this.hideWithDelay, true);
                _this.removeEventOnTargets('keydown', _this.onKeyDown, true);
                _this.removeEventOnTargets('focusin', _this.show, true);
                _this.removeEventOnTargets('focusout', _this.hide, true);
            }
            document.removeEventListener('click', _this.handleDocumentClick, true);
        };
        _this.onMouseOverPopoverContent = function () {
            var _a = _this.props, autoHide = _a.autoHide, isOpen = _a.isOpen;
            var hideTimeout = _this.state.hideTimeout;
            if (_this.props.trigger.indexOf('hover') > -1 && !autoHide) {
                if (hideTimeout) {
                    _this.clearHideTimeout();
                }
                if (isOpen && !isOpen) {
                    _this.toggle();
                }
            }
        };
        _this.onMouseLeavePopoverContent = function (e) {
            var showTimeout = _this.state.showTimeout;
            if (_this.props.trigger.indexOf('hover') > -1 && !_this.props.autoHide) {
                if (showTimeout) {
                    _this.clearShowTimeout();
                }
                e.persist();
                var hideTimeout = setTimeout(function () {
                    _this.hide(e);
                    _this.getDelay('hide');
                });
                _this.setState({ hideTimeout: hideTimeout });
            }
        };
        _this.state = {
            isShow: false,
            targets: [],
            currentTargetElement: null,
            hideTimeout: null,
            showTimeout: null,
            popover: null,
        };
        return _this;
    }
    PopoverWrapper.prototype.componentDidMount = function () {
        this._isMounted = true;
        this.updateTarget();
    };
    PopoverWrapper.prototype.componentWillUnmount = function () {
        this.removeTargetEvents();
        this.setState({ targets: null });
        this.clearShowTimeout();
        this.clearHideTimeout();
        this._isMounted = false;
    };
    PopoverWrapper.prototype.getMenuItems = function () {
        var popover = this.state.popover;
        return [].slice.call(popover.querySelectorAll('[role="menuitem"]'));
    };
    PopoverWrapper.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, placement = _a.placement, className = _a.className, isOpen = _a.isOpen, role = _a.role;
        var currentTargetElement = this.state.currentTargetElement;
        if (!isOpen) {
            return null;
        }
        return (React.createElement(ReactPopper, { referenceElement: currentTargetElement, placement: placement, 
            // positionFixed={true}
            modifiers: placement === 'right-start'
                ? [
                    { name: 'offset', enabled: true, options: { offset: [20, -15] } },
                    { name: 'flip', enabled: false },
                ]
                : [] }, function (_a) {
            var ref = _a.ref, style = _a.style;
            return (React.createElement("div", { ref: _this.getRef },
                React.createElement("div", { ref: ref, style: style, className: className, role: role, onMouseOver: _this.onMouseOverPopoverContent, onMouseLeave: _this.onMouseLeavePopoverContent, onKeyDown: _this.onKeyDown, children: children })));
        }));
    };
    return PopoverWrapper;
}(Component));
export default PopoverWrapper;
//# sourceMappingURL=PopoverWrapper.js.map